export default {
  header: {
    hideMenuBar: 'Menüleiste ausblenden',
    showMenuBar: 'Menüleiste anzeigen'
  }
}
